import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";

export const LoginButton = () => {
  const navigate = useNavigate();

  return (
    <Button className="text-primary font-bold cursor-pointer" variant="link" onClick={() => navigate("/login")}>
      ログイン
    </Button>
  );
};
